import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { MultipleConfig } from '../../../models/multipleConfig.model';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';

@Component({
  selector: 'app-multiple-config',
  templateUrl: './multiple-config.component.html',
  styleUrl: './multiple-config.component.css'
})
export class MultipleConfigComponent {
  @Input() multipleConfig!: MultipleConfig;
  @Input() isGroup!: boolean;
  @Input() multipleAnswers!: boolean;
  @Input() hasIndexText?: boolean;

  @Output() multipleChange = new EventEmitter;

  form: FormGroup = this.fb.group({});
  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.form = this.fb.group({
      initQuantity: [{ value: this.multipleConfig.initQuantity, disabled: !this.isGroup && !this.multipleAnswers }, [Validators.required, this.initQuantityValidator.bind(this)]],
      minQuantity: [{ value: this.multipleConfig.minQuantity, disabled: !this.isGroup && !this.multipleAnswers }, [Validators.required, this.minQuantityValidator.bind(this)]],
      maxQuantity: [{ value: this.multipleConfig.maxQuantity, disabled: !this.isGroup && !this.multipleAnswers }, this.maxQuantityValidator.bind(this)],
      textBtnMultiple: [{ value: this.multipleConfig.textBtnMultiple, disabled: !this.isGroup && !this.multipleAnswers }],
      haveIndexTitles: [{ value: this.multipleConfig.haveIndexTitles, disabled: !this.isGroup && !this.multipleAnswers }]
    });

    this.validateAllFields();

    this.form.valueChanges.subscribe(value => {
      this.multipleConfig.initQuantity = value.initQuantity;
      this.multipleConfig.minQuantity = value.minQuantity;
      this.multipleConfig.maxQuantity = value.maxQuantity;
      this.multipleConfig.textBtnMultiple = value.textBtnMultiple;
      this.multipleConfig.haveIndexTitles = value.haveIndexTitles;
    });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['multipleConfig']) {
      setTimeout(() => {
        this.setValues(changes['multipleConfig'].currentValue);

        if (!this.isGroup && changes['multipleAnswers']) {
          if (this.multipleAnswers === true) {
            this.enableForm();
          } else {
            this.disableForm();
          }
        }
        this.multipleChange.emit();
      }, 0);
    }
  }

  setValues(multipleConfig: MultipleConfig) {
    this.form.setValue({
      initQuantity: multipleConfig.initQuantity,
      minQuantity: multipleConfig.minQuantity,
      maxQuantity: multipleConfig.maxQuantity,
      textBtnMultiple: multipleConfig.textBtnMultiple,
      haveIndexTitles: multipleConfig.haveIndexTitles
    });
  }

  enableForm() {
    this.form.get('initQuantity')?.enable();
    this.form.get('minQuantity')?.enable();
    this.form.get('maxQuantity')?.enable();
    this.form.get('textBtnMultiple')?.enable();
    this.form.get('haveIndexTitles')?.enable();
  }

  disableForm() {
    this.form.get('initQuantity')?.disable();
    this.form.get('minQuantity')?.disable();
    this.form.get('maxQuantity')?.disable();
    this.form.get('textBtnMultiple')?.disable();
    this.form.get('haveIndexTitles')?.disable();
  }

  initQuantityValidator(): ValidationErrors | null {
    const initQuantity = this.form?.get('initQuantity')?.value;
    const minQuantity = this.form?.get('minQuantity')?.value;
    const maxQuantity = this.form?.get('maxQuantity')?.value;

    if (initQuantity != undefined && initQuantity != null)
    {
      if (minQuantity !== undefined && minQuantity !== null && initQuantity < minQuantity)
        {
          this.form.get('initQuantity')?.setValue(minQuantity);
        }
      else if (maxQuantity !== undefined && maxQuantity !== null && initQuantity > maxQuantity)
        {
          this.form.get('initQuantity')?.setValue(maxQuantity);
        }
    }
    else{
      this.form.get('initQuantity')?.setValue(minQuantity);
    }
    return null;
  }

  minQuantityValidator(): ValidationErrors | null {
    const initQuantity = this.form?.get('initQuantity')?.value;
    var minQuantity = this.form?.get('minQuantity')?.value;
    const maxQuantity = this.form?.get('maxQuantity')?.value;

    if (minQuantity !== undefined && minQuantity !== null)
    {
      if (minQuantity < 1)
      {
        this.form.get('minQuantity')?.setValue(maxQuantity !== null && maxQuantity !== undefined ? maxQuantity : 1);
      }
      else if (maxQuantity !== undefined && maxQuantity !== null && minQuantity > maxQuantity)
      {
        this.form.get('minQuantity')?.setValue(maxQuantity);
      }

      minQuantity = this.form?.get('minQuantity')?.value;
      if (initQuantity !== null && initQuantity !== undefined && minQuantity > initQuantity)
      {
        this.form.get('initQuantity')?.setValue(minQuantity);
      }
    }
    else
    {
      this.form.get('minQuantity')?.setValue(maxQuantity !== null && maxQuantity !== undefined ? maxQuantity : 1);
    }
    return null;
  }

  maxQuantityValidator(): ValidationErrors | null {
    const initQuantity = this.form?.get('initQuantity')?.value;
    const minQuantity = this.form?.get('minQuantity')?.value;
    var maxQuantity = this.form?.get('maxQuantity')?.value;

    if (maxQuantity !== null && maxQuantity !== undefined)
    {
      if (minQuantity !== null && minQuantity !== undefined && maxQuantity < minQuantity)
      {
        this.form.get('maxQuantity')?.setValue(minQuantity);
      }

      maxQuantity = this.form?.get('maxQuantity')?.value;
      if (initQuantity !== null && initQuantity !== undefined && maxQuantity < initQuantity)
      {
        this.form.get('initQuantity')?.setValue(maxQuantity);
      }
    }
    return null;
  }

  validateAllFields(): void {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control) {
        control.markAsTouched({ onlySelf: true });
        control.updateValueAndValidity();
      }
    });
  }

  newUpdateListener() {
    this.multipleChange.emit();
  }
}
